import Vue from 'vue'
import PopMessageComponent from '@/views/aiAgent/component/popMessage/PopMessage.vue'

const PopMessageConstructor = Vue.extend(PopMessageComponent)

// 创建右下角容器（全局唯一）
let container = document.getElementById('pop-message-container')
if (!container) {
  container = document.createElement('div')
  container.id = 'pop-message-container'
  container.style.position = 'fixed'
  container.style.top = '20px'
  container.style.left = '50%'
  container.style.transform = 'translateX(-50%)'
  container.style.zIndex = 9999
  container.style.display = 'flex'
  container.style.flexDirection = 'column'
  container.style.alignItems = 'center'
  container.style.pointerEvents = 'none' // 不阻挡页面点击
  document.body.appendChild(container)
}

const createMessage = ({message, type = 'info', duration = 3000,showClose = false, onClose=()=>{}, iconClassName}) => {
  const instance = new PopMessageConstructor({
    propsData: { message, type, duration,showClose,onClose, iconClassName }
  })
  const el = document.createElement('div')
  el.style.pointerEvents = 'all' // 允许点击弹窗
  container.appendChild(el)
  instance.$mount(el)
}
// 核心方法
const popMessage = (options) => {
  console.log(options,'options')
  if (typeof options === 'string') {
    options = { message: options }
  }
  createMessage(options)
}

// 快捷方法
popMessage.success = (msg, duration) => createMessage({ message: msg, type: 'success', duration })
popMessage.error = (msg, duration) => createMessage({ message: msg, type: 'error', duration })
popMessage.warning = (msg, duration) => createMessage({ message: msg, type: 'warning', duration })
popMessage.info = (msg, duration) => createMessage({ message: msg, type: 'info', duration })
// Vue 全局挂载
Vue.prototype.$popMessage = popMessage

export default popMessage
